export default function news_single() {
  
  $('.news-content iframe[src^=https://https://www.youtube.com/embed').each(function(){
    $(this).wrap('<div class="video-wrapper" />');
  });

}